import * as React from 'react';
import { useSelector } from 'react-redux';

import { EHomeownerTrap } from 'shared/containers/valuationTraps/HomeownerTrap/types';
import { isNewbuildingSelector, selectIsAgent, selectIsOfferOwnedByUser } from 'shared/selectors';
import { selectIsCpdAvailable } from 'shared/selectors/cpd/cpd';
import { isSuburbanSelector } from 'shared/selectors/suburban/isSuburbanSelector';
import { selectIsMyHomeObjectsExists, selectEstimationExist } from 'shared/selectors/valuationTraps';

export const useHomeownerTrapVisible = (): EHomeownerTrap | null => {
  const [homeownerTrap, setHomeownerTrap] = React.useState<EHomeownerTrap | null>(null);

  const isMyHomeObjectsExists = useSelector(selectIsMyHomeObjectsExists);
  const isEstimationExist = useSelector(selectEstimationExist);
  const isCpdAvailable = useSelector(selectIsCpdAvailable);

  const isNewbuilding = useSelector(isNewbuildingSelector);
  const isSuburban = useSelector(isSuburbanSelector);
  const isOfferByUser = useSelector(selectIsOfferOwnedByUser);
  const isAgent = useSelector(selectIsAgent);

  React.useEffect(() => {
    if (isCpdAvailable && !isNewbuilding && isOfferByUser && !isAgent) {
      setHomeownerTrap(EHomeownerTrap.cpd);

      return;
    }

    if (!isMyHomeObjectsExists && isEstimationExist && !isSuburban && isOfferByUser && !isAgent) {
      setHomeownerTrap(EHomeownerTrap.myHome);

      return;
    }

    return;
  }, [isMyHomeObjectsExists, isCpdAvailable, isEstimationExist, isNewbuilding, isSuburban, isOfferByUser, isAgent]);

  return homeownerTrap;
};
